import { requestUpdateCreatives, updateCreativesError, updateCreativesSuccess } from '../actions';
import updateCreativesBase from './updateCreativesBase';

const updateCreatives =
    (
        accountId,
        creativeIds,
        changes,
        { suppressSuccessIndication, suppressErrorIndication, updateFunction = updateCreativesBase } = {}
    ) =>
    async dispatch => {
        dispatch(requestUpdateCreatives());

        const { results, error } = await dispatch(
            updateFunction(accountId, creativeIds, changes, { suppressSuccessIndication, suppressErrorIndication })
        );

        if (results) {
            dispatch(updateCreativesSuccess(results));
            return { results };
        } else if (error) {
            dispatch(updateCreativesError(creativeIds, error));
            return { error };
        }
    };

export default updateCreatives;
